export type Plugin = {
  transformRequest?: (req: Request) => Request;
  transformResponse?: (res: Response) => Promise<Response>;
};

export const createClient = (baseUrl = '', ...plugins: Plugin[]) => {
  const fetchFn = (url: string, init?: RequestInit) => {
    const fullUrl = new URL(`${baseUrl}${url}`, window.location.origin);
    const req = new Request(fullUrl.toString(), init);
    const finalReq = plugins.reduce((req, p) => p.transformRequest?.(req) || req, req);

    return fetch(finalReq).then((res) => {
      return plugins.reduce(
        async (res, p) => p.transformResponse?.(await res) || res,
        Promise.resolve(res),
      );
    });
  };

  const postJson = (url: string, body: unknown) => {
    const encodedBody = JSON.stringify(body);
    const init = {
      method: 'POST',
      body: encodedBody,
      headers: { 'content-type': 'application/json' },
    };

    return fetchFn(url, init);
  };

  fetchFn.postJson = postJson;

  return fetchFn;
};

declare global {
  interface Body {
    json<T = unknown>(): Promise<T>;
  }
}
